export const globalSearch = (data, query, fields = []) => {
  if (!query.trim()) return data;

  const q = query.toLowerCase();

  return data.filter((item) => {
    const valuesToSearch =
      fields.length > 0
        ? fields.map((f) => item[f])
        : Object.values(item);

    return valuesToSearch
      .filter((v) => v !== null && v !== undefined)
      .join(" ")
      .toLowerCase()
      .includes(q);
  });
};